import { useEffect, useState } from "react";
import { it } from "date-fns/locale";
import { CalendarDays } from "lucide-react";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const toIt = (s) => { const [y, m, d] = String(s || "").slice(0, 10).split("-"); return y && m && d ? `${d}/${m}/${y}` : ""; };
const toIso = (s) => {
  const m = String(s).trim().match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
  if (!m) return null;
  const d = new Date(+m[3], +m[2] - 1, +m[1]);
  return d.getDate() === +m[1] && d.getMonth() === +m[2] - 1 ? `${m[3]}-${m[2].padStart(2, "0")}-${m[1].padStart(2, "0")}` : null;
};
const toDate = (s) => { const [y, m, d] = String(s || "").slice(0, 10).split("-").map(Number); return y && m && d ? new Date(y, m - 1, d) : undefined; };
const fromDate = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export function DataIt({ label, testid, value, onChange }) {
  const [txt, setTxt] = useState(toIt(value));
  const [open, setOpen] = useState(false);
  useEffect(() => { setTxt(toIt(value)); }, [value]);
  const emit = (iso) => onChange({ target: { value: iso } });
  const onTxt = (v) => { setTxt(v); if (!v.trim()) emit(""); else { const iso = toIso(v); if (iso) emit(iso); } };
  return (
    <div data-field-name={testid}>
      <label className="block text-[11px] font-semibold uppercase tracking-wide text-[var(--muted)] mb-1.5">{label}</label>
      <div className="flex gap-1.5">
        <input data-testid={testid} placeholder="gg/mm/aaaa" value={txt} onChange={(e) => onTxt(e.target.value)} onBlur={() => setTxt(toIt(value))}
          className="flex-1 min-w-0 px-3 py-2.5 rounded-lg bg-white border border-[var(--border)] outline-none text-sm focus:border-[#FC82ED]" />
        <Popover open={open} onOpenChange={setOpen}>
          <PopoverTrigger asChild>
            <button type="button" data-testid={`${testid}-calendario`} className="shrink-0 px-3 rounded-lg border border-[var(--border)] bg-white"><CalendarDays size={15} /></button>
          </PopoverTrigger>
          <PopoverContent className="w-auto p-0 bg-white border border-[var(--border)] shadow-lg z-[200]" align="end">
            <Calendar mode="single" locale={it} weekStartsOn={1} selected={toDate(value)} defaultMonth={toDate(value)} onSelect={(d) => { if (d) emit(fromDate(d)); setOpen(false); }} initialFocus />
          </PopoverContent>
        </Popover>
      </div>
    </div>
  );
}
